module.exports = __webpack_public_path__ + "img/icon_storage_space.19251561.svg";